/** 设置屏「库表版本」卡的判读（#5012，dual-entry E9）。
 *
 * 库表迁移本身只有命令（`python -m someo_keel.db.schema`，入口矩阵豁免「库表迁移」），界面只读展示：
 * 库表版本、是否跟上仓里的迁移文件、模型与迁移文件是否一致。判读全照后端字段，不自己比对。
 */

import type { StoreSchema } from "../api/g4";

export type Tone = "ok" | "warn" | "bad" | "neutral";

export interface SchemaVerdict {
  /** 「库表版本」一栏：版本号或「未迁移」。 */
  version: string;
  migration: { tone: Tone; text: string };
  models: { tone: Tone; text: string };
}

export function schemaVerdict(schema: StoreSchema): SchemaVerdict {
  const migration: SchemaVerdict["migration"] = schema.up_to_date
    ? { tone: "ok", text: `已是最新（${schema.latest ?? "—"}）` }
    : { tone: "bad", text: `落后 ${schema.unapplied.length} 条迁移：${schema.unapplied.join("、")}（部署机运行 python -m someo_keel.db.schema）` };
  let models: SchemaVerdict["models"];
  if (schema.models_match_migrations === null) {
    models = { tone: "warn", text: `判不了${schema.model_check_error ? `：${schema.model_check_error}` : ""}` };
  } else if (schema.models_match_migrations) {
    models = { tone: "ok", text: "一致" };
  } else {
    models = { tone: "bad", text: `不一致：模型有改动但没有迁移文件（${schema.model_changes.join("、") || "未点名"}）` };
  }
  return { version: schema.version ?? "未迁移（库里没有迁移记录）", migration, models };
}
